import React from 'react';

import { compose } from 'redux';

class TeamMembers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // open and close modal
        let root = document.getElementsByTagName('html')[0];
        let openModals = document.querySelectorAll('.open-modal');
        let closeModals = document.querySelectorAll('.close-modal');
        
        openModals.forEach(openModal => {
            openModal.addEventListener('click', () => {
                openModal.closest('.grid-item').querySelector('.mole__team--modal').classList.add('is-showing');
                root.classList.add('bound');
            })
        });

        closeModals.forEach(closeModal => {
            closeModal.addEventListener('click', () => {
                closeModal.closest('.mole__team--modal').classList.remove('is-showing');
                root.classList.remove('bound');
            })
        });

        // close modal on Esc press
        window.addEventListener('keydown', (e) => {
            if (e.key == "Escape") {
                if (document.querySelector('.mole__team--modal.is-showing')) {
                    document.querySelector('.mole__team--modal.is-showing').classList.remove('is-showing');
                    root.classList.remove('bound');
                }
            }
        });
    }

    render() {
        let { members } = this.props;
        let page_id = this.props.page_id;
        let career = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.career : []; 
        // console.log(career.positions_available)
        if(!members) return [];
        return (
            <section className="mole__team--members fullW" id="team">
                <div className="main-container">
                    <div className="inner-container">
                        <h6 className="font-lg-head c-general">Team</h6>
                        <div className="grid fullW">
                            {
                                members.map((member, index) => {
                                    return (
                                        <div className="grid-item">
                                            <figure>
                                                <img src={member.acf.hisher_image.url} alt={member.title.rendered} />
                                                <figcaption>
                                                    <p>{member.title.rendered}</p>
                                                    <p>{member.acf.qualification}</p>
                                                    <p>{member.acf.designation}</p>
                                                </figcaption>
                                                <a href="javascript:" className="open-modal"></a>
                                            </figure>

                                            <div className="mole__team--modal bg-general c-white font-md">
                                                <div className="main-container">
                                                    <div className="inner-container">
                                                        <div className="d-flex flex-column">
                                                            <figcaption>
                                                                <h6>{member.title.rendered}</h6>
                                                                <p className="c-white">{member.designation}</p>
                                                            </figcaption>

                                                            <address>
                                                                {member.acf.email_id && <p><a href={`mailto:${member.acf.email_id}`}>Email</a></p>}
                                                                {member.acf.linkedin_link && <p><a target='_blank' href={member.acf.linkedin_link}>Linkedin</a></p>}
                                                            </address>
                                                        </div>

                                                        <article className="desc" dangerouslySetInnerHTML={{__html:member.acf.content}} />

                                                        <figure>
                                                            <img src={member.acf.details_image.url} alt={member.title.rendered} title={member.title.rendered}/>
                                                        </figure>

                                                        <a href='javascript:void(0)' className="link btn_prev close-modal c-txt c-hvr-white">Back</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                career && career.positions_available == 1 &&
                                    <div className="grid-blank-item bg-general c-white">
                                        {
                                            career.section_title &&
                                                <p className="w-100 font-md">{career.section_title}</p>
                                        }
                                        {
                                            career.get_in_touch_text &&
                                                <p className="w-100"><a href={`mailto:${career.email_id}?subject=${career.email_subject}`}>{career.get_in_touch_text}</a></p>
                                        }
                                    </div>
                            }
                            
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default TeamMembers;



// WEBPACK FOOTER //
// ./src/components/Team/TeamMembers.js